{
    "Boolean": "checkbox",
    "String": "input",
    "Int32": "number",
    "Int64": "number",
    "Double": "number",
    "Decimal": "number",
    "DateTime": "ngx-bootstra-datepicker"
}  